// extracted by mini-css-extract-plugin
export default {"numbers":"NumbersTable_numbers__HUi-R","backlink":"NumbersTable_backlink__IAnXo"};